import axios from 'axios'
import router from '../router'
import { message } from '@/utils/message'
import { baseUrl } from './url'
import store from '../store/index'
import { showScreenLoading, hideScreenLoading } from "../utils/loading";
const instance = axios.create({
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json'
  }
})

let flag = true

let requests = []
// 请求拦截
instance.interceptors.request.use((config) => {

  config.headers.Authorization = `Bearer ${getlocalToken()}`
  if (config.headers.showLoading !== false) {
    if (config.data && config.data.loading == false) {
    }
    else if (config.params && config.params.loading == false) {
    } else {
      showScreenLoading(config.headers);

    }
  }

  // if (config.headers.showLoading !== false  && !config.url.indexOf('loading') >= 0) {
  //   showScreenLoading(config.headers);
  // }
  if (config.url.indexOf('/Refreshtoken') >= 0 || config.url.indexOf('/login') >= 0 || config.url.indexOf('/CompanyUserLogin') >= 0 || config.url.indexOf('/GetLoginToken') >= 0 || config.url.indexOf('/getVierificationCode') >= 0 || config.url.indexOf('/QRCodeEnter') >= 0 || config.url.indexOf('/ServiceRecommendLog/Add') >= 0 || config.url.indexOf('/BankBusiness/Detail') >= 0 || config.url.indexOf('/GetInfoPartial') >= 0 || config.url.indexOf('/GetVierificationCode') >= 0 || config.url.indexOf('/GetUnlimitedQRCode') >= 0 || config.url.indexOf('/SendSms') >= 0 || config.url.indexOf('/LoginByNoteVerificationCode') >= 0 || config.url.indexOf('/RetrievePassword') >= 0 || config.url.indexOf('/ForgetPasswod') >= 0 || config.url.indexOf('/ApplyEdit') >= 0 || config.url.indexOf('/SuggestEdit') >= 0 || config.url.indexOf('/Park/List') >= 0 || config.url.indexOf('/RegisterIndividualAccount') >= 0 || config.url.indexOf('/LoginByWeChatScanQRcode') >= 0) {
    return config
  }

  if (getlocalToken()) {
    if (isExpired()) {
      if (flag) {
        console.log('过期')
        flag = false
        config.headers.Authorization = `Bearer ${getlocalToken()}`
        refreshToken()
          .then(() => {
            var token = getlocalToken()
            return token
          })
          .then((token) => {
            requests.forEach((cb) => cb(token))
            // 执行完成后，清空队列
            requests = []
          })
          .catch(() => {
            return config
          })
      }
      const retryOriginalRequest = new Promise((resolve) => {
        requests.push((token) => {
          // 因为config中的token是旧的，所以刷新token后要将新token传进来
          config.headers.Authorization = `Bearer ${token}`
          resolve(config)
        })
      })
      return retryOriginalRequest
    } else {
      config.headers.Authorization = `Bearer ${getlocalToken()}`
      return config
    }
  }
}, error => {
  if (config.headers.showLoading !== false) {
    hideScreenLoading(config.headers);
  }
  this.$message.error("请求超时!");
  return Promise.reject(error);
})

// 响应拦截
instance.interceptors.response.use(
  (response) => {
    if (response.config.url.indexOf('/Export') !== -1) {
      setTimeout(() => {
        if (response.config.headers.showLoading !== false) {
          hideScreenLoading();
        }
      }, 100);
      return response
    } else {
      setTimeout(() => {
        if (response.config.headers.showLoading !== false) {
          hideScreenLoading();
        }
      }, 100);
      return response.data
    }
  },
  (error) => {
    const status = error.response?.status
    console.log(error);
    // if (response.config.headers.showLoading !== false) {
    //   hideScreenLoading();
    // }
    hideScreenLoading();

    switch (status) {
      case 401:
      case 403:
        var lirm = localStorage.getItem('lirm')
        var lap = localStorage.getItem('lap')
        window.localStorage.removeItem('Authorization')
        window.localStorage.removeItem('userInfo')
        //如果记住密码，则留存
        if (lirm == 1) {
          localStorage.setItem('lap', lap)
        }
        message.error('会话超时，请重新登录')
        store.state.tabList = []
        if (router.history.current.path.indexOf('console') !== -1) {
          router.replace('/console')
        } else {
          store.state.tabList = []
          router.replace('/login')
        }
        break
      case 404:
        message.error('请求资源不存在')
        break
      case 500:
        message.error('服务器错误')
        break
      default:
        message.error(res.msg)
        break;

    }
    return Promise.resolve(error)
  }
)

// 判断token是否过期
function isExpired() {
  const expiredTime = (localStorage.getItem('Authorization') && JSON.parse(localStorage.getItem('Authorization')).expiresAt) || 0
  if (!expiredTime) return false
  var currentTimestamp = Date.parse(new Date()) / 1000
  if (currentTimestamp >= expiredTime - 300) {
    return true
  } else {
    return false
  }
}

// 获取本地缓存token
function getlocalToken() {
  const frontToken = JSON.parse(localStorage.getItem('Authorization')) ? JSON.parse(localStorage.getItem('Authorization')).token : ''
  const adminToken = JSON.parse(localStorage.getItem('admin_Authorization')) ? JSON.parse(localStorage.getItem('admin_Authorization')).token : ''
  return frontToken || adminToken
}

// 请求token
function refreshToken() {
  return instance({
    method: 'get',
    url: `${baseUrl.primary}/v3/User/CompanyManageUser/Refreshtoken`
  })
    .then((res) => {
      if (res.code === 0) {
        console.log(res.data)
        localStorage.setItem('Authorization', JSON.stringify(res.data))
        flag = true
      } else {
        flag = false
      }
    })
    .catch((err) => {
      console.log(err)
    })
}

export default instance
